import type { AssistantToolCall } from '../../api/types';

/**
 * Transparencia de datos: que ha mirado Alexia para responder.
 *
 * Va plegado porque no interrumpe la lectura, pero tiene que estar siempre
 * ahi: el duenyo necesita poder comprobar de donde sale cada cifra.
 */
export function ToolCallList({ calls }: { calls: AssistantToolCall[] }): JSX.Element | null {
  if (calls.length === 0) return null;

  return (
    <details className="tool-calls">
      <summary className="tool-calls__summary">
        Ver de dónde salen estos datos ({calls.length}{' '}
        {calls.length === 1 ? 'consulta' : 'consultas'})
      </summary>
      <ul className="tool-calls__list">
        {calls.map((call, index) => (
          <li className="tool-calls__item" key={`${call.name}-${index}`}>
            <span className="tool-calls__text">{call.summary}</span>
          </li>
        ))}
      </ul>
      <p className="tool-calls__note">
        Para responder, Alexia solo consulta tus datos: no cambia ni borra nada sin que lo confirmes.
      </p>
    </details>
  );
}
